// AUTO-GENERATED from public/images — do not edit by hand.
// Re-run: node scripts/gen-images.mjs (or the inline generator).

export const residenzeImages: string[] = [
  '/images/residenze/1e3fb2_08cdf60d9f37454f941f6302220f843c.jpg',
  '/images/residenze/1e3fb2_0e6631bb18834e85bb687e44627edb68.jpg',
  '/images/residenze/1e3fb2_2545ee69040c4e13a1b84506b8efe4cb.jpg',
  '/images/residenze/1e3fb2_5e8a171b94484f258964212ea5d9565c.jpg',
  '/images/residenze/1e3fb2_870df27da8c6482f8606cc87bdc9c4c9.jpg',
  '/images/residenze/1e3fb2_8ade2da9684f465d8c44f5a7348eb277.jpg',
  '/images/residenze/1e3fb2_98e68741c987489bad5f0d5f673f49e2.jpg',
  '/images/residenze/1e3fb2_b7a5664a9ae84182a4d43a8a3f225364.jpeg',
  '/images/residenze/1e3fb2_c3f75f3b5bea4937b9837efd8bd0c094.jpg',
  '/images/residenze/1e3fb2_cbf97e92d78540feba271643d9999d23.jpg',
  '/images/residenze/1e3fb2_f37a4371eb2f454caf14fce53a56c634.jpg',
  '/images/residenze/1e3fb2_fb0af05596c043129d69d93f2d678a1c.jpg',
];

export const retailImages: string[] = [
  '/images/retail/1e3fb2_7683810e1491441ab1792ede4d2776e8.jpg',
  '/images/retail/1e3fb2_8ed8a9bb061342de91dfe186fa2e9e94.jpg',
  '/images/retail/1e3fb2_9e5952de9faa499c833738a92a77e2c1.jpg',
  '/images/retail/1e3fb2_a3e1590f7e1d471aa924d7209462475d.jpg',
  '/images/retail/1e3fb2_aedbeae0007b4c1eb744f35deab909b7.jpg',
  '/images/retail/1e3fb2_af8f4ceed75640c280096bc01786da59.jpg',
  '/images/retail/1e3fb2_d6eb18ed298540f1a9b4c61332a54221.jpg',
];

export const productImages: string[] = [
  '/images/product/1e3fb2_0b37ee1d14584beba9b9ccb4c3b4e08d.jpg',
  '/images/product/1e3fb2_2f8fd6ba1ee0404499c7fa8cfbdfdd5f.jpg',
  '/images/product/1e3fb2_4068c400f0a44fee9867da7ed60c948e.jpeg',
  '/images/product/1e3fb2_513669cc41a944909fec2d8a70bed639.jpg',
  '/images/product/1e3fb2_59e0c1ebf9b742ab8aab21cbe2a8d1ca.jpg',
  '/images/product/1e3fb2_5d56773fe09742318679b54c5b87ac60.jpeg',
  '/images/product/1e3fb2_7b2d8b55cb8f4699819818aaa7b07bcc.jpg',
  '/images/product/1e3fb2_83a9f43382734f858c38a2d6c9e78957.jpg',
  '/images/product/1e3fb2_c8340ac355244fe2aabd5192353bef9c.jpg',
  '/images/product/1e3fb2_ce60cf4687b14123919f9e5d226726d6.jpg',
  '/images/product/1e3fb2_da1ff034d49f4d7eb87716b1d40708d6.jpg',
  '/images/product/1e3fb2_f7879f820bcf4caba907eac5b4385103.jpg',
];

export const progettiImages: string[] = [
  '/images/progetti/1e3fb2_1d5eb2f212c747daaeff1f8943494620.jpg',
  '/images/progetti/1e3fb2_2cd22e132d6c44889eae2cd1fa2c8c49.jpg',
  '/images/progetti/1e3fb2_2d661c59c40c49709010d5f1b591a559.jpg',
  '/images/progetti/1e3fb2_39620c7cbe184f13a579f0dbc21fd20e.jpg',
  '/images/progetti/1e3fb2_4b1a3f1909314abdaf43dc378e04ae6d.jpg',
  '/images/progetti/1e3fb2_4f5f742b8b8f4ff6b55dfa19b2053c0a.jpg',
  '/images/progetti/1e3fb2_624773b9688840028bbe7c0e385df473.jpg',
  '/images/progetti/1e3fb2_6eb5553293ca400f88f98d9f3c1a397c.jpg',
  '/images/progetti/1e3fb2_85976e62207141c79aeec8c4f93cf23a.jpg',
  '/images/progetti/1e3fb2_8a80c4e6e9a046119c075b4ff8f10612.jpg',
  '/images/progetti/1e3fb2_ccae5b3009ed4ddda1620fe4b6be88cf.jpg',
  '/images/progetti/1e3fb2_da6ed4a5f93f4898a492baa27cdec2c2.jpg',
  '/images/progetti/1e3fb2_e58257501f3d47c8b6c435cbae608056.jpg',
];

export const studioImages: string[] = [
  '/images/studio/1e3fb2_5ac9660d212047daab838d5b0da0b667.jpg',
  '/images/studio/1e3fb2_6bdfad70ae5f403dabf3e722b2ff0b29.jpg',
  '/images/studio/1e3fb2_7bae8d30ef8048378f64609f758457c3.jpg',
  '/images/studio/1e3fb2_869681d0ceb7425cbf925cec4488467b.jpg',
  '/images/studio/1e3fb2_90a2d707875849b690db461b08b9dd75.jpg',
  '/images/studio/1e3fb2_922d32f02bcc4b35b133fc90e4655560.jpg',
];

export const homeImages: string[] = [
  '/images/home/1e3fb2_48d5acc6a3e449829eb3c9efc22bcd66.jpg',
  '/images/home/1e3fb2_48db366a5e994fcf9962787531880284.jpeg',
  '/images/home/1e3fb2_5bb4fa37fc4e44f19e5500895bd643ff.jpg',
  '/images/home/1e3fb2_85aca33cc296473ca203a8bd01a24f59.jpg',
  '/images/home/1e3fb2_a9cdc8f8471144dda8628bc00dbf596f.jpg',
  '/images/home/1e3fb2_ac0affd625dd44538b29b9eb83cd48fb.jpeg',
  '/images/home/1e3fb2_baffc8818ecf4841913811fc3b1d2ed6.jpg',
  '/images/home/1e3fb2_bd8dbd0e2571460794851456eb9e2877.jpg',
  '/images/home/1e3fb2_d15cabe3001f475584aea399b4ac8f2b.jpg',
  '/images/home/1e3fb2_d2958f40b6664a1fb909a61eafbee101.jpg',
  '/images/home/1e3fb2_e2a385644578440eaad372952548dd82.jpg',
  '/images/home/1e3fb2_fd3493134fb84dd69c2b8a5a4ebc796b.jpg',
];

